import { defineAction } from '~/prix'
import { z } from 'zod'
import veterinarySymptomCreateAction from './veterinarySymptomCreate.action.json' with { type: 'json' }
import { veterinarySymptomObject } from '../veterinarySymptomObject'

const veterinarySymptomCreateDefinition = defineAction({
  ...veterinarySymptomCreateAction,

  input: veterinarySymptomObject
    .pick({
      title: true,
      observations: true,
    })
    .extend({
      id: veterinarySymptomObject.shape.id.nullish(),
    }),
  output: z.object({
    id: veterinarySymptomObject.shape.id,
  }),
})

export default veterinarySymptomCreateDefinition
